// export const VUE_APP_API_URL = "https://xcmapi.123xiaocaimi.com/api"; //prod
// export const VUE_APP_API_URL = "http://175.27.163.26:10048/api"; //test
// // // export const VUE_APP_API_URL = "http://127.0.0.1:8005/api"; //local
// export const VUE_APP_API_OUT_URL = "https://xcmapi.123xiaocaimi.com/third-trend"; // 外部接口
// export const VUE_APP_API_OUT_URL5000 = "https://xcmapi.123xiaocaimi.com/third-trend5000"; // 外部接口
// export const VUE_APP_API_OUT_URL = "/third-trend"; // 外部接口
// export const VUE_APP_RESOURCES_URL = "https://xcmstatic.123xiaocaimi.com";


// prod
export const VUE_APP_API_URL = "https://xcmapi.123xiaocaimi.com/api"; //prod
export const VUE_APP_API_OUT_URL = "/third-trend"; // 外部接口
export const VUE_APP_API_OUT_URL5000 = "/third-trend5000"; // 外部接口
export const VUE_APP_RESOURCES_URL = "https://xcmstatic.123xiaocaimi.com";